import * as React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { compose } from 'redux';
import { Drawer, Notification } from 'components/';
import * as Queries from 'api/graphql/queries';
import * as Mutations from 'api/graphql/mutations';
import { AdminPaymentMethodsList, AdminPaymentMethodsList_adminPaymentMethods, OrderDirection } from '@api/graphql/types';
import { RowInfo } from 'react-table';
import Paths from '../paths';
import { BooleanCell, OpenInNewCell } from '@components/Table/Cell';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { SortingRule } from 'react-table';
import ReduxTable from '@components/ReduxTable';

interface StateType {
    adminPaymentMethods: Array<(AdminPaymentMethodsList_adminPaymentMethods | null)>;
}

type Props = InjectedIntlProps & RouteComponentProps;

export const PaymentMethodListDefaultOptions = {
    sortBy: {
        field: 'sort',
        direction: OrderDirection.ASC,
    },
    count: 10,
    page: 0,
    filters: {},
};

const listName = 'paymentMethodList';

class PaymentMethodList extends React.Component<Props, StateType> {
    private defaultSorted: SortingRule[] = [{id: 'sort'}];

    private SortCell = (row : any) => {
        if (!this.state || !this.state.adminPaymentMethods) {
            return <span>{row.value}</span>;
        }

        const index = this.state.adminPaymentMethods.indexOf(row.original);
        const isFirst = index === 0;
        const isLast = index === this.state.adminPaymentMethods.length - 1;

        return (
            <div style={{display: 'flex', flexFlow: 'row wrap'}}>
                <div style={{flex: '0 0 50%'}}>
                    {!isFirst && <a onClick={this.move(row.original, 'before', this.state.adminPaymentMethods![(index - 1)]!.id)}><i className="fa fa-chevron-up" /></a>}
                </div>
                <div style={{flex: '0 0 50%'}}>
                    {!isLast && <a onClick={this.move(row.original, 'after', this.state.adminPaymentMethods![(index + 1)]!.id)}><i className="fa fa-chevron-down" /></a>}
                </div>
            </div>
        );
    }

    private move = (item: AdminPaymentMethodsList_adminPaymentMethods, direction: 'before' | 'after', id: string) => (e: React.SyntheticEvent) => {
        e.preventDefault();
        e.stopPropagation();

        GraphQLClient.mutate({
            mutation: Mutations.updatePaymentMethod,
            variables: {...item, [direction]: id},
        }).then(() => {
            this.fetchData();
            Notification.success(this.props.intl.formatMessage({ id: 'notification.succeed' }));
        }).catch((error: any) => {
            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    public componentDidMount() {
        this.fetchData();
    }

    public fetchData() {
        GraphQLClient.query<AdminPaymentMethodsList>({
            query: Queries.adminPaymentMethods,
        }).then((response) => {
            if (response.data) {
                this.setState({adminPaymentMethods: response.data.adminPaymentMethods});
            }
        });
    }

    private OpenCell = OpenInNewCell((rowInfo: any) => {
        return `${Paths.paymentMethod}/${rowInfo.original.id}`;
    });

    private tableColumns = [
        {Header: '', sortable: false, Cell: this.OpenCell, width: 30},
        this.getDefaultColumnByName('id'),
        this.getDefaultColumnByName('name'),
        this.getDefaultColumnByName('is_active', {Cell: BooleanCell}),
        this.getDefaultColumnByName('sort', {Cell: this.SortCell}),
        this.getDefaultColumnByName('short_description', {sortable: false}),
    ];

    private getDefaultColumnByName(name: string, options: any = {}) {
        return {
            Header: this.label(`${name}.title`),
            accessor: name,
            sortable: true,
            ...options,
        };
    }

    private label(id: string): string {
        return this.props.intl.formatMessage({ id: `module.paymentMethod.${id}` });
    }

    private renderList() {
        if (this.state && this.state.adminPaymentMethods) {
            return (
                <ReduxTable
                    listName={listName}
                    defaultOptions={PaymentMethodListDefaultOptions}
                    onClick={(rowInfo: RowInfo) => {
                        this.props.history.push(`${Paths.paymentMethod}/${rowInfo.original.id}`);
                    }}
                    data={this.state.adminPaymentMethods}
                    columns={this.tableColumns}
                    defaultPageSize={10}
                    defaultSorted={this.defaultSorted}
                    sortable={false}
                    filterable={false}
                />
            );
        }
        return null;
    }

    public render() {
        return (
            <Drawer>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-content">
                                {this.renderList()}
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        );
    }
}

export default compose(
    withRouter,
    injectIntl,
)(PaymentMethodList);



// WEBPACK FOOTER //
// ./src/modules/PaymentMethod/pages/PaymentMethodList.tsx